(function ($, Drupal) {
  'use strict';

  var site = window.site = window.site || {};

  site.client = site.client || {};
  var basicCarouselItemV1 = {
    formatter: $('.basic-carousel-item-v1')
  };

  Drupal.behaviors.basicCarouselItemV1 = {
    get: function (key) {
      return basicCarouselItemV1[key];
    },

    set: function (key, val) {
      basicCarouselItemV1[key] = val;
    },

    attach: function (context, settings) {
      var self = this;
      var formatter = $(self.get('formatter'), context);

      formatter.each(function () {
        var thisFormatter = $(this);
        // Make whole carousel item clickable
        var $wrapper = thisFormatter.find('.wrapper'),
          $wrapperUrl = thisFormatter.find('.wrapper-url'),
          url = $wrapperUrl.data('wrapper-url'),
          $carousel = thisFormatter.closest('.basic-carousel');

        $carousel.addClass('basic-carousel-item-formatter');
        if ($wrapperUrl.length) {
          thisFormatter.css({ 'cursor': 'pointer' }).wrap('<a href="' + url + '"></a>');
        }

        // Get mobile img height
        var isMobile = $('body').hasClass('device-mobile'),
          isPortrait = window.innerHeight > window.innerWidth,
          isLandscape = window.innerHeight < window.innerWidth,
          isTablet = window.innerWidth < 1367; // smaller than iPad Pro landscape (1366px) mode and down

        if (isTablet) { // check if this is a tablet or smaller mobile device
          window.addEventListener('orientationchange', function () {
            if (screen.orientation.angle == 90) { // landscape
              $carousel.addClass('landscape');
            }
            if (screen.orientation.angle == 0) { // portrait
              $carousel.removeClass('landscape');
            }
          });
        }
      });
      // carousel height for mobile portrait
      // based on the tallest image/copy containers
      $(document).on('ajaxComplete', function (e) {
        var $mainCarousel = $('.basic-carousel', context);
        var $highestCopyContainer;
        var $highestImageContainer;
        var heightCopy = 0;
        var heightImage = 0;

        $('.basic-carousel-item-copy__header-wrapper', $mainCarousel).each(function () {
          var hCopy = $(this).height();

          if (hCopy > heightCopy) {
            heightCopy = hCopy;
            $highestCopyContainer = $(this);
          }
        });
        $('.mobile-img', $mainCarousel).each(function () {
          var hImg = $(this).height();

          if (hImg > heightImage) {
            heightImage = hImg;
            $highestImageContainer = $(this);
          }
        });
        if (!!$highestCopyContainer && !!$highestImageContainer) {
          var carouselHeight = $highestCopyContainer.height() + $highestImageContainer.height() + 'px';

          // mobile portrait
          if (site.client.isMobile && (window.innerHeight > window.innerWidth)) {
            $mainCarousel.css({ 'height': carouselHeight });
          }
        }
      });
    }
  };
})(jQuery, Drupal);
